import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Text } from '../../../../core/design-system/components/Text';
import { Button } from '../../../../core/design-system/components/Button';
import './CompletionStep.css';

const CompletionStep = ({ onComplete }) => {
  const { t } = useTranslation('onboarding');
  const [credits, setCredits] = useState(0);

  useEffect(() => {
    const creditInterval = setInterval(() => {
      setCredits(prev => prev < 5 ? prev + 1 : prev);
    }, 200);

    return () => clearInterval(creditInterval);
  }, []);

  const handleComplete = () => {
    onComplete({});
  };

  return (
    <div className="completion-step-container">
      <div className="completion-step-content">
        <div className="credits-display">
          <Text variant="h1" className="credits-number">
            {credits}
          </Text>
          <Text variant="body1" className="credits-text">
            {t('completion.credits')} 🎁
          </Text>
        </div>
      </div>

      <Button 
        variant="primary"
        onClick={handleComplete}
        className="step-submit-button"
      >
        {t('completion.button')}
      </Button>
    </div>
  );
};

export default CompletionStep; 